module.exports = __webpack_public_path__ + "static/dg-db7a15598397a225fd41684e33ec2912.png";